module.exports = __webpack_public_path__ + "assets/img/COUPLE1.ab20463b.png";